export default {"src":"/_next/static/media/Skin Allergies.a223c384.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};